<template>
  <div class="os-application-wrapper oxia-theme-default" :class="{ 'mt-0': !showNavbar }">
    <Navbar />
    <div class="ow-page-content">
      <slot></slot>
    </div>
    <WebsiteFooter v-if="showFooter" class="background-to-transparent" />
  </div>
</template>

<script setup>
const router = useRouter();

const showNavbar = computed(() => {
  const currentRoute = router.currentRoute;
  if (currentRoute.value.name !== 'book-your-appointment') return true;
  return false;
});

const showFooter = computed(() => {
  const currentRoute = router.currentRoute;
  if (currentRoute.value.name == 'book-your-appointment') return true;
  else if (currentRoute.value.name !== 'book-your-appointment') return true;
  return false;
});
</script>

<style scoped></style>
